.clamp-class {
  --clamp-lines-length-var: 2;
  display: -webkit-box;
  -webkit-line-clamp: var(--clamp-lines-length-var);
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
